(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["happy-saffron-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const proceed = (button, modal, cart) => {
      // With the add-on in the cart, also put its code in the checkout URL so the $15 off survives a lost discount cookie.
      // Codes already on the cart (email or VIP codes) are kept alongside it.
      const returnTo = modal && modal.dataset.code && button.form && button.form.querySelector('input[name="return_to"]');
      if (returnTo && returnTo.value.startsWith('/checkout')) {
        const codes = ((cart && cart.discount_codes) || []).filter((d) => d.applicable !== false).map((d) => d.code);
        if (!codes.includes(modal.dataset.code)) codes.push(modal.dataset.code);
        returnTo.value = '/checkout?discount=' + codes.map(encodeURIComponent).join(',');
      }
      button.dataset.hsUpsellDone = '1';
      button.click();
    };
    // During the Black Friday sale the gummies are the free gift, so the $24.99 add-on offer is paused.
    const salePaused = (modal) => modal.hasAttribute('data-bf-pause') && ['live', 'friday', 'weekend', 'cyber'].includes(document.documentElement.dataset.bf || '');
    const close = (modal) => {
      modal.hidden = true;
      document.documentElement.classList.remove('hs-upsell-open');
    };
    // First two slides load when the shopper clicks Add to cart, the rest once they swipe.
    const loadSlides = (modal, all) => {
      modal.querySelectorAll('[data-hs-up-track] img').forEach((img, i) => {
        if (!img.dataset.srcset || (!all && i > 1)) return;
        img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        delete img.dataset.srcset;
      });
    };
    const initCarousel = (modal) => {
      const box = modal.querySelector('[data-hs-up-carousel]');
      if (!box || box.dataset.ready) return;
      box.dataset.ready = '1';
      const track = box.querySelector('[data-hs-up-track]');
      const slides = [...track.children];
      if (slides.length < 2) {
        box.classList.add('is-single');
        return;
      }
      let current = 0;
      const go = (i) => {
        const slide = slides[(i + slides.length) % slides.length];
        loadSlides(modal, true);
        track.scrollTo({ left: slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2, behavior: 'smooth' });
      };
      const dots = slides.map((slide, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Show image ${i + 1} of ${slides.length}`);
        dot.addEventListener('click', () => go(i));
        box.querySelector('[data-hs-up-dots]').append(dot);
        return dot;
      });
      const update = () => {
        const middle = track.scrollLeft + track.clientWidth / 2;
        const distance = (slide) => Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - middle);
        current = slides.reduce((best, slide, i) => (distance(slide) < distance(slides[best]) ? i : best), 0);
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
      };
      let ticking = false;
      track.addEventListener('scroll', () => {
        loadSlides(modal, true);
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          update();
        });
      }, { passive: true });
      track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          go(current + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      box.querySelector('[data-hs-up-prev]').addEventListener('click', () => go(current - 1));
      box.querySelector('[data-hs-up-next]').addEventListener('click', () => go(current + 1));
      update();
    };
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-hs-add]');
      if (!button || button.dataset.hsUpsellDone) return;
      const section = button.closest('[data-hs-product-section]');
      const modal = section && section.querySelector('[data-hs-upsell]');
      if (!modal) return;
      if (salePaused(modal)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      loadSlides(modal, false);
      let cart = null;
      try {
        cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        if (cart.items.some((item) => String(item.variant_id) === modal.dataset.variant)) {
          proceed(button, modal, cart);
          return;
        }
      } catch (error) {
        /* show the offer anyway */
      }
      modal.hidden = false;
      document.documentElement.classList.add('hs-upsell-open');
      initCarousel(modal);
      modal.querySelector('[data-hs-upsell-yes]').focus({ preventScroll: true });
      modal.onclick = async (e) => {
        if (e.target.closest('[data-hs-upsell-close]')) {
          close(modal);
          button.dataset.hsUpsellDone = '1';
          return;
        }
        if (e.target.closest('[data-hs-upsell-no]')) {
          close(modal);
          proceed(button);
          return;
        }
        const yes = e.target.closest('[data-hs-upsell-yes]');
        if (!yes) return;
        yes.disabled = true;
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(modal.dataset.variant), quantity: 1 }] }),
          });
          if (modal.dataset.code) {
            await fetch('/discount/' + encodeURIComponent(modal.dataset.code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' });
          }
        } catch (error) {
          /* continue to checkout even if the add-on fails */
        }
        close(modal);
        proceed(button, modal, cart);
      };
    }, true);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') document.querySelectorAll('[data-hs-upsell]:not([hidden])').forEach(close);
    });
  })();

  document.querySelectorAll('[data-hs-sticky]').forEach((bar) => {
    const form = bar.closest('[data-hs-product-section]').querySelector('form.hs-product-form');
    if (!form) return;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      }).observe(form);
    } else {
      window.addEventListener('scroll', () => bar.classList.toggle('is-visible', form.getBoundingClientRect().bottom < 0), { passive: true });
    }
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-hs-sticky-link]');
    if (!link) return;
    const target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-hs-gallery-trigger]');
    if (!trigger) return;
    const gallery = trigger.closest('[data-hs-gallery]');
    const panelId = trigger.getAttribute('aria-controls');
    gallery.querySelectorAll('[data-hs-gallery-panel]').forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });
    gallery.querySelectorAll('[data-hs-gallery-trigger]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button === trigger));
    });
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-hs-variant]');
    if (!select) return;
    const section = select.closest('[data-hs-product-section]');
    const option = select.selectedOptions[0];
    const button = section.querySelector('[data-hs-add]');
    const available = option.dataset.available === 'true';
    section.querySelector('[data-hs-price]').textContent = option.dataset.price;
    const compare = section.querySelector('[data-hs-compare]');
    compare.hidden = !option.dataset.compare;
    compare.textContent = option.dataset.compare || '';
    button.disabled = !available;
    section.querySelector('[data-hs-add-label]').textContent = available ? button.dataset.availableText : button.dataset.unavailableText;
    const stock = section.querySelector('[data-hs-stock]');
    stock.textContent = available ? stock.dataset.availableText : stock.dataset.unavailableText;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-research-wall"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hs-research]').forEach((wall) => {
    const studies = [...wall.querySelectorAll('[data-hs-study]')];
    const more = wall.querySelector('[data-hs-research-more]');
    const initial = Number(wall.dataset.initial) || 6;
    let expanded = false;
    let filter = 'all';
    const render = () => {
      let shown = 0;
      studies.forEach((study) => {
        const match = filter === 'all' || study.dataset.hsStudy === filter;
        const visible = match && (expanded || filter !== 'all' || shown < initial);
        study.hidden = !visible;
        if (visible) shown += 1;
      });
      if (more) more.closest('.hs-research-more').hidden = expanded || filter !== 'all';
    };
    wall.querySelectorAll('[data-hs-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        filter = button.dataset.hsFilter;
        wall.querySelectorAll('[data-hs-filter]').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
        render();
      });
    });
    if (more) more.addEventListener('click', () => { expanded = true; more.setAttribute('aria-expanded', 'true'); render(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-hs-reviews-more]').forEach((button) => {
    button.addEventListener('click', () => {
      button.closest('[data-hs-reviews]').querySelectorAll('[data-hs-review-overflow]').forEach((review) => { review.hidden = false; });
      button.parentElement.hidden = true;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hs-video-wall"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const videos = [...document.querySelectorAll('[data-hs-video] video[data-poster]')];
    const setPoster = (video) => { if (!video.poster) video.poster = video.dataset.poster; };
    if (!('IntersectionObserver' in window)) { videos.forEach(setPoster); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) { setPoster(entry.target); io.unobserve(entry.target); } });
    }, { rootMargin: '600px 600px' });
    videos.forEach((video) => io.observe(video));
  })();
  document.addEventListener('click', (event) => {
    const play = event.target.closest('[data-hs-video-play]');
    if (!play) return;
    const video = play.closest('[data-hs-video]').querySelector('video');
    document.querySelectorAll('[data-hs-video] video').forEach((other) => { if (other !== video) other.pause(); });
    video.controls = true;
    play.hidden = true;
    video.play();
  });
  document.addEventListener('ended', (event) => {
    const frame = event.target.closest && event.target.closest('[data-hs-video]');
    if (!frame) return;
    event.target.controls = false;
    frame.querySelector('[data-hs-video-play]').hidden = false;
  }, true);

  } catch(e) { console.error(e); }
})();
})();
